<template>
  <div>
    <div  v-if="loading">
      <skeleton-revenue />
    </div>
    <div class="vuse-content-wrapper mt-4" v-if="customers">
      <div>
          <v-row >
            <v-col>
              <h2 class="ml-3">
                {{$t(page+'.Pricelists')}}
                <span>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">     
                      <v-btn icon color="primary" v-on="on" @click="xmlReport">
                        <ExcelIcon />
                      </v-btn>
                    </template>
                    <span>Download Table as CSV</span>
                  </v-tooltip>
                </span>
                <span>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">     
                      <v-btn icon color="primary" v-on="on" @click="loadData">
                        <v-icon>sync</v-icon>
                      </v-btn>
                    </template>
                    <span>Refresh</span>
                  </v-tooltip>
                </span>
              </h2>
            </v-col>
            <v-spacer /> 
          </v-row>
          <template v-if="!customers && !loading">
            <no-data />  
          </template>
          <template v-else>  
            <v-row class="pl-1 px-5 mt-2">
              <v-col cols="12" md="12" class="mx-2">
                <v-card class="neu-glow pb-4">
                  <v-card-title class="pb-0">
                    <v-row>
                      <v-col cols=12 sm="6" lg="3">
                        <v-text-field
                            v-model="search"
                            append-icon="search"
                            :label="$t(page+'.Search')"
                            single-line
                            hide-details
                        ></v-text-field>
                      </v-col>
                      <v-spacer></v-spacer>
                      <v-btn color="success" @click="save($event, -1, 'active')"  class="mt-6">
                        <v-icon left>
                          fas fa-plus
                        </v-icon>
                          {{$t(page+'.Add New')}}
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-col cols=12 sm="6" lg="2">
                        <v-text-field reverse append-outer-icon="fas fa-euro-sign" :label="$t(page+'.Simulation Cost')" class="text-h5" v-model="simulation" :value="(simulation/1).toFixed(2)"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card-title>
                  <v-data-table
                      v-if="customers"
                      fixed-header="true"
                      :headers="headers"
                      :items="customers"
                      :items-per-page="Math.floor((wIH - 348-85.95)/95.07)"
                      :height="wIH - 348"
                      :search="search"
                      multi-sort
                      class="elevation-1 mx-4"
                      :loading="loading" 
                      loading-text="Loading... Please wait"

                  >
                    <template #item.index="{ item }">
                      {{ customers.indexOf(item)+1 }}
                    </template>
					
                    <template v-slot:item.active="{ item }">
                      <v-tooltip top :disabled="item.used==0&&item.pricelistName!='P1'">
                        <template v-slot:activator="{ on }">
                          <div v-on="on">
                            <v-switch :disabled="item.used>0||item.pricelistName=='P1'" :readonly="item.used>0" :id="item.id" name="active" color="primary" @change="save($event, item.id, 'active')" v-model="item.active"></v-switch>
                          </div>
                        </template>
                        <span v-html="$t(page+'.PriceList in use or default: cannot disable')"></span>
                      </v-tooltip>
                    </template>

                    <template v-slot:item.used="{ item }">
                      <v-simple-checkbox disabled color="primary" v-model="item.used"></v-simple-checkbox>
                    </template>

                    <template v-slot:item.pricelistName="{ item }">
                        <v-text-field 
                          :readonly="item.pricelistName=='P1'" 
                          :hint="item.pricelistName=='P1'?$t(page+'.Default Pricelist: cannot change Name'):''"
                          :persistent-hint="item.pricelistName=='P1'"
                          dense @input.native="save" :id="item.id" class="pt-7 text-h5" filled name="pricelistName" v-model="item.pricelistName">
                        </v-text-field>
                    </template>

                    <template v-slot:item.fixed="{ item }">
                      <v-text-field dense @input.native="save" :id="item.id" class="pt-7 text-h5" filled reverse name="fixed" v-model="item.fixed" append-outer-icon="fas fa-euro-sign" :value="(item.fixed/1).toFixed(2)"></v-text-field>
                    </template>

                    <template v-slot:item.variable="{ item }">
                      <v-text-field dense @input.native="save" :id="item.id" class="pt-7 text-h5" filled reverse name="variable" v-model="item.variable" append-outer-icon="fas fa-percent" :value="(item.variable/1).toFixed(2)"></v-text-field>
                    </template>

                    <template v-slot:item.simulation="{ item }">
                      <v-text-field dense reverse append-outer-icon="fas fa-euro-sign" class="pt-7 text-h5" filled :value="item.fixed+item.variable=='undefined'?'':((simulation/1+item.fixed/1)*(1+item.variable/100)).toFixed(2)"></v-text-field>
                    </template>

                  </v-data-table>
                  </v-card>
              </v-col>
            </v-row>
          </template>
        </div>
    </div>
    <v-dialog v-model="msg_modal" max-width="850">
      <v-card class="overflow-hidden">
        <v-card-title class="text-h5"
          >Send a Message</v-card-title
        >
          <v-row  class="mt-5">
            <v-col cols="12" md="6">
              <v-img
                src="/static/ob-animated/sent-message-animate.svg"
                lazy-src="/static/ob-animated/sent-message-animate.svg"
                style="height:100%"
              ></v-img>
            </v-col>
            <v-col>
              <v-card-text class="mt-2">
                <p>Send a Message to... {{username}}</p>
                  <v-text-field
                    label="Subject"
                    placeholder="Subject"
                    outlined
                    v-model="msg.subject"
                  ></v-text-field>
                  <v-textarea
                    outlined
                    v-model="msg.body"
                    name="input-7-4"
                    label="Message Text"
                  ></v-textarea>
                <div class="text-left mt-5">
                  <v-row>
                    <v-col cols="12" class="text-center">
                      <v-btn 
                        class="ml-5"
                        color="primary"
                        @click="messageSend"
                      >Send</v-btn>
                    </v-col>
                  </v-row>
                  </div>
              </v-card-text>
            </v-col>
          </v-row>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" absolute centered :color="snackbar_color">
      <span>{{snackbar_message}}</span>
    </v-snackbar>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import NoData from "@/components/NoData";
import ExcelIcon from "@/components/Excel";
import SkeletonRevenue from "@/components/SkeletonRevenue";
import _ from 'lodash'

export default {
  components: { NoData, SkeletonRevenue, ExcelIcon },
  computed : {
    ...mapGetters(["user"]),
  },
  data() {
    return {
      namespace: "Reports",
      page: "BossOutstanding",
      UserID:null,
      username:'',
      msg_modal:false,
      msg:{},
      loading: true,
      errorid: null,
      simulation:5,
      search: '',
      wIH:window.innerHeight,      
      priceLists:['P1','P2','P3','P4','P5','P6','P7'],
      customers: null,
      snackbar:false,
      snackbar_message:'',
      snackbar_color:'',
      headers: [
          { text: '#', align: 'start', value: 'index'},
          { text: 'Used', value: 'used',align: 'middle', class : 'text-subtitle-1 font-weight-black primary--text py-4', 'width': '10%' },
          { text: 'Active', value: 'active',align: 'middle', class : 'text-subtitle-1 font-weight-black primary--text py-4', 'width': '10%' },
          //{ text: 'Class', value: 'serviceCode',align: 'middle', class : 'text-subtitle-1 font-weight-black primary--text py-4' },
          { text: 'PriceList Name', value: 'pricelistName',align: 'middle', class : 'text-subtitle-1 font-weight-black primary--text py-4' , width: '20%'},
          { text: 'Fixed Charges', value: 'fixed',align: 'middle', class : 'text-subtitle-1 font-weight-black primary--text py-4', width: '20%' },
          { text: '% Charges', value: 'variable',align: 'middle', class : 'text-subtitle-1 font-weight-black primary--text py-4', width: '20%' },
          { text: 'Simulation', value: 'simulation',align: 'middle', class : 'text-subtitle-1 font-weight-black primary--text py-4', width: '20%' },
        ],      
    };
  },
  created(){
    this.loadData()
  },
  methods:
  {
    save: _.debounce(function (event,id='',field='') {
        this.formReadOnly=true;
        console.log(216,event,id,field);
        let payload=''
        if (field=='')
        {
          payload={"action":"edit_pricelist","payload":{"table":"PriceLists","field":event.target.name,"value":event.target.value,"key":"id","keyValue":event.target.id}};
        }
        else
        {
          payload={"action":"edit_pricelist","payload":{"table":"PriceLists","field":field,"value":event==false?0:1,"key":"id","keyValue":id}};
        }
        console.log(226,payload)
        this.update_db(payload)
        //this.updateDB(event.target.name,event.target.value)
    }, 1000), 
    async update_db(payload){
      let jwt=sessionStorage.getItem('jwt');
      try{
          console.log(232,payload);
          
          const res = await this.$http.post('/boss/actions.php', {"jwt":jwt,'payload':payload});
          console.log(238,res.data);
          switch (res.data.errorid)
          {
            case '0':
              sessionStorage.setItem('jwt', res.data.jwt);
              this.snackbar_color='success';
              this.snackbar_message=res.data.message;
              this.snackbar=true;
              console.log(252,payload.id,res.data.payload,this.isJson(res.data.payload),this.customers)
              if (res.data.payload!='0')
              {
                this.customers.unshift(JSON.parse(res.data.payload));
                console.log(254,this.customers);
              }
             break;
          }
          return res.data;
      } 
      catch(e)
      {
        console.log(e);
          this.snackbar_color='red darken-2';
          this.snackbar_text='Connection Error - Try Later';
      }
      this.snackbar=true;
      return null;
    },
    isJson(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
    },
     openModal(userid,username)
    {
      this.msg_modal=true;
      this.msg.userid=userid;
      this.username=username;

    },
    async xmlReport(){
      let jwt=sessionStorage.getItem('jwt');
      let payload={"jwt":jwt};
      window.location.href='/ajax/boss/customers_xls.php?json='+encodeURIComponent(JSON.stringify(payload));
    },
    async loadData(){
      let jwt=sessionStorage.getItem('jwt');
      this.loading=true;
      try
      {
          const res = await this.$http.post('/boss/pricelists.php', {"jwt":jwt});
          this.loading= false;
          this.errorid=res.data.errorid;
          switch (res.data.errorid)
          {
            case '0':
              this.customers=res.data.payload.table;
              //console.log(this.customers);
            break;

            case '0001':
              this.data.datasets[0].data = res.data.payload.data0;
              this.data.datasets[1].data = res.data.payload.data1;
              this.data.datasets[2].data = res.data.payload.data1;
              this.data.datasets[3].data = res.data.payload.data1;
              this.data.labels = res.data.payload.labels; 
            break;

            case '0006':
              this.$router.push('/auth/login').catch(() => {});
            break;
          }

      }
      catch(e)
      {
          this.loading= false;
      }
    },
    async impersonate(e,p)
    {
      if(p)
      {
        this.loader=true;    
    	  //localStorage.clear();
	      localStorage.removeItem('user');
	      //sessionStorage.clear();
	      sessionStorage.removeItem('jwt');
        try
        {
          const res = await this.$http.post('/auth/login.php', {email: e, password: p, rememberme: true})
          this.errorid=res.data.errorid;
          if (res.data.errorid=='0')
          {
            sessionStorage.setItem('jwt', res.data.jwt);
            res.data.user.jwt=res.data.jwt;
            this.$store.dispatch("setUser", res.data.user); 
            this.$store.dispatch("setFixings", res.data.fixings);
            //this.$store.dispatch("setLocale", res.data.user.locale);
            //this.$store.dispatch("setCurrency", res.data.user.currency);
            //this.$store.dispatch("set_timeframe", res.data.user.timeframe); 
            
            if (res.data.ls_user)
            {
              localStorage.setItem('user', JSON.stringify(res.data.ls_user));
              //localStorage.setItem('user', res.data.user);
            }
            else
            {
              localStorage.removeItem('user');
            }
            this.$router.push('/'+res.data.user.landingpage).catch(() => {});
          }
          else
          {
            this.message=res.data.message;
            this.dialog=true;
          }
        }       
        catch(e)
        {
          this.$router.push('/auth/login').catch(() => {});
        }
        this.loader=false;
      }
      else
      {
        this.snackbar=true;
        this.snackbar_text='Missing PWD';
        this.snackbar_color='red';
      }
    },
  }
};
</script>